import React, { useState } from 'react';
import { type WedlogBizVendor } from '../types';

interface VendorSearchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (vendor: WedlogBizVendor) => void;
}

export const VendorSearchModal: React.FC<VendorSearchModalProps> = ({ isOpen, onClose, onSelect }) => {
  const [wedlogSearchTerm, setWedlogSearchTerm] = useState('');

  // Mock 데이터
  const wedlogBizVendors: WedlogBizVendor[] = [
    { id: 'WB001', name: '로얄 스튜디오', category: '웨딩상품', subCategory: '스튜디오', contact: '02-1111-2222', manager: '김로얄', email: 'royal@studio.co.kr', address: '서울시 강남구 청담동 123', businessNumber: '111-22-33444', rating: 4.9, isPartner: true, categoryIdx: 1 },
    { id: 'WB002', name: '엘레강스 드레스', category: '웨딩상품', subCategory: '드레스', contact: '02-2222-3333', manager: '박엘레', email: 'elegance@dress.co.kr', address: '서울시 강남구 압구정로 456', businessNumber: '222-33-44555', rating: 4.7, isPartner: true, categoryIdx: 2 },
  ];

  const filteredWedlogVendors = wedlogBizVendors.filter(vendor =>
    vendor.name.toLowerCase().includes(wedlogSearchTerm.toLowerCase()) ||
    vendor.manager.toLowerCase().includes(wedlogSearchTerm.toLowerCase())
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-xl font-bold">WedlogBiz 파트너 업체 검색</h2>
            <p className="text-sm text-gray-600 mt-1">WedlogBiz와 연동된 업체를 검색하여 간편하게 등록하세요</p>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 w-6 h-6 flex items-center justify-center cursor-pointer">
            <i className="ri-close-line"></i>
          </button>
        </div>

        <div className="mb-6">
          <div className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 flex items-center justify-center"></i>
            <input
              type="text"
              placeholder="업체명, 담당자, 카테고리로 검색..."
              value={wedlogSearchTerm}
              onChange={(e) => setWedlogSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="space-y-4 max-h-96 overflow-y-auto">
          {filteredWedlogVendors.map((vendor) => (
            <div 
              key={vendor.id}
              className="border border-gray-200 rounded-lg p-4 hover:border-green-300 hover:bg-green-50 transition-colors cursor-pointer"
              onClick={() => onSelect(vendor)}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <i className="ri-building-line text-xl text-green-600"></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="font-semibold text-gray-800">{vendor.name}</h3>
                      <span className="inline-flex px-2 py-1 text-xs font-medium rounded bg-green-100 text-green-700">WedlogBiz 파트너</span>
                      <span className="inline-flex px-2 py-1 text-xs font-medium rounded bg-purple-100 text-purple-700">{vendor.subCategory}</span>
                    </div>
                    <div className="flex items-center gap-4 text-sm text-gray-600">
                      <span>담당: {vendor.manager}</span>
                      <span>{vendor.contact}</span>
                      <span>{vendor.email}</span>
                    </div>
                    <p className="text-sm text-gray-600 mt-1">{vendor.address}</p>
                  </div>
                </div>
                <div className="text-right">
                  <div className="flex items-center gap-1 mb-1">
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-${i < Math.floor(vendor.rating) ? 'fill' : 'line'} text-sm`}></i>
                      ))}
                    </div>
                    <span className="text-sm font-medium text-gray-700">{vendor.rating}</span>
                  </div>
                  <button className="text-green-600 text-sm font-medium hover:text-green-700">선택하기 →</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredWedlogVendors.length === 0 && (
          <div className="text-center py-12">
            <i className="ri-search-line text-4xl text-gray-300 mb-4"></i>
            <p className="text-gray-500">검색 결과가 없습니다.</p>
          </div>
        )}
      </div>
    </div>
  );
};
